import { useCountryStore } from "./stores/countryStore";
import { LIVE_COUNTRIES } from "./utils/network";

/**
 * Client side of the build-time prerender (plan Phase 8; see
 * src/entry-server.tsx and scripts/prerender.mts).
 */

function normalisePath(path: string): string {
  const trimmed = path.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

/** True when #root holds prerendered markup for exactly this pathname. */
export function isPrerenderedFor(container: HTMLElement, pathname: string): boolean {
  const route = container.dataset.npPrerendered;
  if (route === undefined || !container.hasChildNodes()) return false;
  return normalisePath(route) === normalisePath(pathname);
}

/**
 * Put client stores in the state the prerender saw, so the first client
 * render matches the server HTML. The prerender always uses the bundled
 * LIVE_COUNTRIES seed; a session-cached network would differ, so drop to the
 * seed and let useNetwork's background refresh bring the live list in.
 */
export function seedStoresForHydration(): void {
  if (useCountryStore.getState().networkSource === "fallback") return;
  useCountryStore.setState({ network: LIVE_COUNTRIES, networkSource: "fallback", networkFetchedAt: null });
}
